// extracted by mini-css-extract-plugin
export var TermsServicesWrapper = "TermsServicesContent-module--TermsServicesWrapper--5o4Pl";